import { Model, Store } from 'store/Base';
import { observable } from 'mobx';
import { Company } from './Company';
import { ProjectModuleStore } from './ProjectModule';
import { MilestoneStore } from './Milestone';
import { SubprojectStore } from './Subproject';
import { Team } from './Team';
import { User } from './User';
import { ProjectTeamMemberStore } from './ProjectTeamMember';
import { Thread } from '../module/notes/store/Thread';


export class Project extends Model {
    static backendResourceName = 'project';

    static omitFields = ['fullName'];

    @observable id = null;
    @observable name = '';

    @observable fullName = '';
    @observable hidden = false

    @observable quotationLink = '';

    @observable company = this.relation(Company);

    @observable projectModules = this.relation(ProjectModuleStore)

    @observable milestones = this.relation(MilestoneStore);

    // [T54539 follow-up] Sub projects of this project (the company viewport
    // fetches them through this relation, so sub projects without a budget
    // show up too — the old budget-only path hid those).
    @observable subprojects = this.relation(SubprojectStore);

    @observable team = this.relation(Team);

    @observable projectLead = this.relation(User);

    @observable teamMembers = this.relation(ProjectTeamMemberStore);

    @observable commentNoteThread = this.relation(Thread);

    @observable lastComment = '';

    // annotations for the budget of this project
    @observable hasActiveBudget = false;

    // [T53675 follow-up] Whether time registrations link to this project
    // (directly or via a sub project) — such projects cannot be deleted.
    @observable hasTimeRegistrations = false;

    // T53675: customer viewport shows whether we plan against a real
    // commercial agreement (support / fixed fee) or an unpaid project.
    @observable projectType = 'unpaid';

    @observable monthlyBudgetHoursMin: null | number = null;
    @observable monthlyBudgetHoursMax: null | number = null;
    @observable fixedBudgetHours: null | number = null;

    @observable monthlyTimeSpend: null | number = null;
    @observable lastMonthTimeSpend: null | number = null;
    @observable fixedTimeSpend: null | number = null;

    @observable milestonesCompletedCount = 0;
    @observable milestonesWipCount = 0;
    @observable milestonesNotStartedCount = 0

    // Backend annotation: last time-registration on this project by ANY user.
    // Used to filter stale projects out of planning views.
    @observable lastActivity = '';

}

export class ProjectStore extends Store {
    Model = Project;
    static backendResourceName = 'project';
}
